import autenticacaoApi from "../../api/autenticacaoApi";
import authLocalStorage from "../../utils/authLocalStorage";
import { SET_TOKEN, DELETE_TOKEN } from "../mutations.type";

export const namespaced = true;

export const state = {
  token: authLocalStorage.getTokenAcesso() || ""
};

export const mutations = {
  [SET_TOKEN](state, token) {
    state.token = token;
  },
  [DELETE_TOKEN](state) {
    state.token = "";
  }
};

export const actions = {
  login({ commit }, { chaveAcesso }) {
    authLocalStorage.salvarTokenAcesso(chaveAcesso);
    return autenticacaoApi.entrar(chaveAcesso).then(() => {
      commit(SET_TOKEN, chaveAcesso);
      return chaveAcesso;
    });
  },
  logout({ commit }) {
    return new Promise(resolve => {
      commit(DELETE_TOKEN);
      authLocalStorage.invalidarSessao();
      resolve(true);
    });
  }
};

export const getters = {};
